<script setup lang="ts">
import { computed } from "vue";

import MenuItemDelimiter from "@/components/menu/MenuItemDelimiter.vue";
import PageHeader from "@/components/menu/PageHeader.vue";
import IterationItem from "@/components/search/dropdown/IterationItem.vue";
import StickyTypeItem from "@/components/search/dropdown/StickyTypeItem.vue";
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import ToggleButton from "@/components/ui/ToggleButton/ToggleButton.vue";
import ToggleItem from "@/components/ui/ToggleButton/ToggleItem.vue";
import { useActivityStore } from "@/store/activity";
import { useSessionStore } from "@/store/session";

import DateFilter from "./internal/DateFilter.vue";

const store = useActivityStore();

// before, we had no events for sticky moves
const MIN_DATE_FOR_VISUAL = new Date(2026, 0, 1);

const visualize = computed(() => useSessionStore().current.creationDate > MIN_DATE_FOR_VISUAL);

function close() {
  store.inactivate();
}
</script>

<template>
  <PageHeader :title="$t('boardDiff.boardTitle')" icon="general/board-history" @close="close">
    <ToggleButton
      class="mode-toggle"
      :model-value="store.tab"
      @update:model-value="store.setTab($event)"
    >
      <ToggleItem value="log">{{ $t("boardDiff.log.title") }}</ToggleItem>
      <ToggleItem value="compare">{{ $t("boardDiff.compare.title") }}</ToggleItem>
      <ToggleItem v-if="visualize" value="visualize">
        {{ $t("boardDiff.visualize.title") }}
      </ToggleItem>
    </ToggleButton>

    <MenuItemDelimiter />

    <div>
      <BaseTooltip :content="$t('boardDiff.dateRange')">
        <DateFilter
          v-model="store.selectedDate"
          :values="store.dateFilterOptions"
          :range="store.tab !== 'visualize'"
        />
      </BaseTooltip>
    </div>

    <MenuItemDelimiter />

    <StickyTypeItem :store :disabled="store.tab === 'visualize'" />
    <IterationItem :store :disabled="store.tab === 'visualize'" />
  </PageHeader>
</template>
